import { Routes, Route } from "react-router-dom";
import "@/App.css";
import ProgressBar from "@/components/ProgressBar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Synopsis from "@/components/Synopsis";
import Intermission from "@/components/Intermission";
import ReadCTA from "@/components/ReadCTA";
import Episodes from "@/components/Episodes";
import MailingList from "@/components/MailingList";
import Footer from "@/components/Footer";
import Admin from "@/components/Admin";
import { Toaster } from "@/components/ui/sonner";

function Landing() {
  return (
    <div className="App scanlines" data-testid="landing-page">
      <div className="noise-overlay" />
      <ProgressBar />
      <main>
        <Hero />
        <Marquee />
        <Synopsis />
        <Intermission />
        <ReadCTA />
        <Episodes />
        <MailingList />
      </main>
      <Footer />
      <Toaster theme="dark" position="bottom-right" />
    </div>
  );
}

function App() {
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/admin" element={<Admin />} />
    </Routes>
  );
}

export default App;
